import React from "react";

import svg from "../../assets/images/icons/file_download.svg";

export const FileDownloadIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "File Download"}
    />
);
